<template>
	<div>
		<div class="headline">Snapshot Results</div>

		<v-alert
			v-if="loading"
			type="info"
			icon="fa-spin fa-spinner"
		>
			Loading
		</v-alert>
		<div v-if="interims.length > 0">
			<div class="title mt-3 mb-1">Interim Results</div>
			<v-simple-table dense>
				<thead>
					<tr>
						<th>StartOffset</th>
						<th>EMAT</th>
						<th>EMATc</th>
						<th>HeartRate</th>
						<th>LVST</th>
						<th>LVSTc</th>
						<th>SDI</th>
						<th>S3Time</th>
						<th>S4Time</th>
						<th>S3</th>
						<th>S4</th>
						<th>QRSd</th>
						<th>PRint</th>
						<th>QTc</th>
						<th>S1Intensity</th>
						<th>S2Intensity</th>
						<th>S1Complexity</th>
						<th>S2Complexity</th>
						<th>SNR</th>
					</tr>
				</thead>
				<tbody>
					<tr v-for="row in interims" :key="row.id">
						<td>{{row.startOffset}}</td>
						<td>{{row.emat}}</td>
						<td>{{row.emaTc}}</td>
						<td>{{row.heartRate}}</td>
						<td>{{row.lvst}}</td>
						<td>{{row.lvsTc}}</td>
						<td>{{row.sdi}}</td>
						<td>{{row.s3Time}}</td>
						<td>{{row.s4Time}}</td>
						<td>{{row.s3}}</td>
						<td>{{row.s4}}</td>
						<td>{{row.qrSd}}</td>
						<td>{{row.pRint}}</td>
						<td>{{row.qTc}}</td>
						<td>{{row.s1Intensity}}</td>
						<td>{{row.s2Intensity}}</td>
						<td>{{row.s1Complexity}}</td>
						<td>{{row.s2Complexity}}</td>
						<td>{{row.snr}}</td>
					</tr>
				</tbody>
			</v-simple-table>
		</div>
		<div v-if="final">
			<div class="title mt-3 mb-1">Final Results</div>
			<v-simple-table dense>
				<thead>
				<tr>
					<th>EMAT</th>
					<th>EMATc</th>
					<th>HeartRate</th>
					<th>LVST</th>
					<th>LVSTc</th>
					<th>SDI</th>
					<th>S3Time</th>
					<th>S4Time</th>
					<th>S3</th>
					<th>S4</th>
					<th>QRSd</th>
					<th>PRint</th>
					<th>QTc</th>
					<th>S1Intensity</th>
					<th>S2Intensity</th>
					<th>S1Complexity</th>
					<th>S2Complexity</th>
					<th>SNR</th>
				</tr>
				</thead>
				<tbody>
				<tr>
					<td>{{final.emat}}</td>
					<td>{{final.emaTc}}</td>
					<td>{{final.heartRate}}</td>
					<td>{{final.lvst}}</td>
					<td>{{final.lvsTc}}</td>
					<td>{{final.sdi}}</td>
					<td>{{final.s3Time}}</td>
					<td>{{final.s4Time}}</td>
					<td>{{final.s3}}</td>
					<td>{{final.s4}}</td>
					<td>{{final.qrSd}}</td>
					<td>{{final.pRint}}</td>
					<td>{{final.qTc}}</td>
					<td>{{final.s1Intensity}}</td>
					<td>{{final.s2Intensity}}</td>
					<td>{{final.s1Complexity}}</td>
					<td>{{final.s2Complexity}}</td>
					<td>{{final.snr}}</td>
				</tr>
				</tbody>
			</v-simple-table>
		</div>
	</div>
</template>

<script>
import api from "../../api";

export default {
	props: {
		id: String,
	},
	data() {
		return {
			loading: true,
			final: null,
			interims: [],
		};
	},
	created() {
		api.snapshotData(this.id).then((r) => {
			this.final = r.data.final;
			this.interims = r.data.interims;

			this.loading = false;
		}, (e) => {
			this.showError(e);
			this.loading = false;
		});
	},
};
</script>
